package com.hyperether.goodjob.scenes.addNew

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Card
import androidx.compose.material.Icon
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.navigation.NavHostController
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.navigation.*
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.add_client
import com.hyperether.goodjob.resources.add_new
import com.hyperether.goodjob.resources.add_new_contact
import com.hyperether.goodjob.resources.add_new_employee
import com.hyperether.goodjob.resources.add_new_job
import com.hyperether.goodjob.resources.briefcase2
import com.hyperether.goodjob.resources.create_new_employee
import com.hyperether.goodjob.resources.create_new_task
import com.hyperether.goodjob.resources.file_text__1_
import com.hyperether.goodjob.resources.user_plus
import com.hyperether.goodjob.scenes.components.ErrorDialog
import com.hyperether.goodjob.scenes.components.MobileHeaderBackAndAction
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.Constants.DEFAULT_CONTACT_ID
import com.hyperether.goodjob.util.Constants.DEFAULT_EMPLOYEE_ID
import com.hyperether.goodjob.util.Constants.DEFAULT_JOB_ID
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun AddNew(navHostController: NavHostController, addNewViewModel: AddNewViewModel) {

    var selectedIndex = remember { mutableStateOf(-1) }
    val errorMessage = remember { mutableStateOf("") }
    val showErrorDialog = remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        if (!getPlatformChecker().isMobile()) {
            addNewViewModel.init()
        }
    }

    Column {
        MobileHeaderBackAndAction(
            title = stringResource(Res.string.add_new),
            back = { navHostController.navigateUp() }
        )
        Spacer(modifier = Modifier.height(15.toScaleDp()))

        SelectableCard(
            isSelected = selectedIndex.value == 0,
            onClick = {
                selectedIndex.value = 0
                navHostController.navigate(AddNewJob(DEFAULT_JOB_ID))
                addNewViewModel.showPopUpSuccess.value = false
            },
            icon = Res.drawable.file_text__1_,
            mainText = stringResource(Res.string.add_new_job),
            subText = stringResource(Res.string.create_new_task)
        )

        SelectableCard(
            isSelected = selectedIndex.value == 1,
            onClick = {
                selectedIndex.value = 1
                navHostController.navigate(AddNewUser(DEFAULT_EMPLOYEE_ID))
                addNewViewModel.showPopUpSuccess.value = false
            },
            icon = Res.drawable.user_plus,
            mainText = stringResource(Res.string.add_new_employee),
            subText = stringResource(Res.string.create_new_employee)
        )

        SelectableCard(
            isSelected = selectedIndex.value == 2,
            onClick = {
                selectedIndex.value = 2
                navHostController.navigate(AddNewContact(DEFAULT_CONTACT_ID))
                addNewViewModel.showPopUpSuccess.value = false
            },
            icon = Res.drawable.briefcase2,
            mainText = stringResource(Res.string.add_new_contact),
            subText = stringResource(Res.string.add_client)
        )

        if (showErrorDialog.value) {
            ErrorDialog(
                onDismiss = { showErrorDialog.value = false },
                title = "",
                message = errorMessage.value
            )
        }

//        FilledButton(
//            onClick = {
//                if (selectedIndex.value == 0) {
//                    navHostController.navigate(Screen.AboutContact.route)
//                    addNewViewModel.showPopUpSuccess.value = false
//                } else if (selectedIndex.value == 1) {
//                    navHostController.navigate(Screen.AddNewEmployee.route)
//                    addNewViewModel.showPopUpSuccess.value = false
//                } else if (selectedIndex.value == 2) {
//                    navHostController.navigate(Screen.AddNewContact.route)
//                    addNewViewModel.showPopUpSuccess.value = false
//                }
//            },
//            modifier = Modifier.padding(start = Dp(16f), end = Dp(16f), top = Dp(30f)),
//            text = stringResource(Res.string.create),
//            isEnabled = true
//        )
    }
}

@Composable
fun SelectableCard(
    isSelected: Boolean,
    onClick: () -> Unit,
    icon: DrawableResource,
    mainText: String,
    subText: String
) {
    Card(
        shape = RoundedCornerShape(12.toScaleDp()),
        border = BorderStroke(
            if (isSelected) 2.toScaleDp() else 1.toScaleDp(),
            if (isSelected) BlueApp else Color.LightGray
        ),
        modifier = Modifier
            .padding(start = 16.toScaleDp(), end = 16.toScaleDp(), top = 15.toScaleDp())
            .fillMaxWidth()
            .clickableWithPointer { onClick() }
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(16.toScaleDp())
        ) {

            Icon(
                painter = painterResource(icon),
                contentDescription = null,
                modifier = Modifier.size(24.toScaleDp())
            )

            Column(
                modifier = Modifier.padding(start = 8.toScaleDp())
            ) {

                Text(
                    text = mainText,
                    fontSize = 18.toScaleSp(),
                    color = TextColor,
                    fontWeight = FontWeight.Bold
                )

                Spacer(modifier = Modifier.height(8.toScaleDp()))

                Text(
                    text = subText,
                    fontSize = 14.toScaleSp(),
                    color = Color.Gray
                )
            }
        }
    }
}